import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as TncActions from "../actionTypes/tncActionTypes";
import * as TncActionCreators from "../actionCreators/tncActionCreator"
import { submitTncConsent } from "../services/APIservice";
import { getTncContent } from "../services/APIservice";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";


function* getTnc() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TncActionCreators.getTncRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getTncContent);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TncActionCreators.getTncSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TncActionCreators.getTncFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TncActionCreators.getTncFailure(error))
    }
  }
}

function* submitTosConsent({ request }: TncActions.SubmitTncConsentAction) {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(TncActionCreators.submitTncConsentRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(submitTncConsent, request);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(TncActionCreators.submitTncConsentSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(TncActionCreators.submitTncConsentFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(TncActionCreators.submitTncConsentFailure(error))
    }
  }
}

function* watchOnSubmitTncConsent() {
  yield takeEvery(TncActions.SUBMIT_TNC_CONSENT, submitTosConsent)
}

function* watchOnGetTnc() {
  yield takeEvery(TncActions.GET_TNC, getTnc)
}

export default function* TncSaga() {
  yield all([
    fork(watchOnSubmitTncConsent),
    fork(watchOnGetTnc)
  ]);
}
